export default {
  footer: {
    tagline: 'منصة إدارة التوصيل مدعومة بالذكاء الاصطناعي لمساعدة الشركات على أتمتة الإرسال وتحسين المسارات وإسعاد العملاء.',
    aiCommandHint:
      'مركز قيادة IA: تخصيص تلقائي للناقلين والسائقين، تخطيط مسارات بالوكلاء، تنبيهات ذكية ووكلاء IA في برج تحكم واحد.',
    product: 'المنتج',
    builtFor: 'حسب القطاع',
    resources: 'الموارد',
    company: 'الشركة',
    compare: 'المقارنة',
    links: {
      compareHub: 'مقارنة كل المنصات',
      howItWorks: 'كيف يعمل',
      brandedTracking: 'التتبع بالعلامة',
      routePlanner: 'مخطط المسارات',
      aiAgents: 'وكلاء الذكاء الاصطناعي',
      autoAllocation: 'التخصيص التلقائي',
      driverApp: 'تطبيق السائق',
      cashManagement: 'إدارة النقد',
      proofOfDelivery: 'إثبات التوصيل',
      reportsAnalytics: 'التقارير والتحليلات',
      restaurants: 'المطاعم وQSR',
      pharmacies: 'الصيدليات',
      retail: 'التجزئة',
      ecommerce: 'التجارة الإلكترونية',
      couriers: 'المراسلة واللوجستيات',
      grocery: 'البقالة والمتاجر',
      allIndustries: 'جميع القطاعات',
      caseStudies: 'دراسات الحالة',
      blog: 'المدونة',
      roiCalculator: 'حاسبة العائد على الاستثمار',
      whitepapers: 'الورقات البيضاء',
      aboutUs: 'من نحن',
      pricing: 'الأسعار',
      partners: 'الشركاء',
      integrations: 'التكاملات',
      contact: 'اتصل بنا',
      altRoutific: 'بديل Routific',
      altShipday: 'بديل Shipday',
      altOnfleet: 'بديل Onfleet',
      altTookan: 'بديل Tookan',
      altCircuit: 'بديل Circuit',
      altOptimoroute: 'بديل OptimoRoute',
      altRoute4me: 'بديل Route4Me',
      altBringg: 'بديل Bringg',
      altDetrack: 'بديل Detrack',
      altLocus: 'بديل Locus',
      altDispatchtrack: 'بديل DispatchTrack',
      altTrackPod: 'بديل Track-POD',
      altUpper: 'بديل Upper',
      altZeo: 'بديل Zeo',
    },
    language: 'اللغة',
    terms: 'شروط الخدمة',
    privacy: 'سياسة الخصوصية',
    rights: 'جميع الحقوق محفوظة.',
    location: { title: 'موقعنا', eyebrow: 'المقر الرئيسي', hq: 'المقر الرئيسي لـ Geofleet', cta: 'افتح في الخرائط', contact: 'تواصل معنا' },
  },
};
